import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-feature-popover',
  templateUrl: './feature-popover.component.html',
  styleUrls: ['./feature-popover.component.scss'],
})
export class FeaturePopoverComponent implements OnInit {

  @Input() data: string;

  constructor() { }

  ngOnInit() {}

}
